import { Component, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

import * as Highcharts from "highcharts";
import { DashboardGlobalService } from "../../core/service/dashboard-global.service";
import { DashboardAllMarcheService } from "../../core/service/dashboard-all-marche.service";
import { QuantiteDossierPortefeuilleParProfileDTO } from "../../core/model/quantite-dossier-portefeuille-par-profile-dto";
import { QuantiteDossierPortefeuilleParDepartementDTO } from "../../core/model/quantite-dossier-portefeuille-par-departement-dto";
import { DashboardDossierStatut } from '../../core/model/DashboardDossierStatut';
import { NewDashboardCorporateService } from '../../core/service/new-dashboard-corporate.service';

@Component({
  selector: "app-global-productivite",
  templateUrl: "./global-productivite.component.html",
  styleUrls: ["./global-productivite.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      )
    ])
  ]
  //
})
export class GlobalProductiviteComponent implements OnInit {
  //DEPARTEMENT
  displayedDepartementColumnsList: string[] = [
    "departement",
    "nombreDossierEnCours",
    "nombreDossierValide",
    "nombreDossierACorriger",
    "actions"
  ];
  dossiersDepartements: QuantiteDossierPortefeuilleParDepartementDTO[];
  expandedElement2: QuantiteDossierPortefeuilleParDepartementDTO | null;

  dossiersProfilesArray: Array<QuantiteDossierPortefeuilleParProfileDTO[]> = [];

  highcharts = Highcharts;
  //chartOptionsRankingEncours: any;
  //chartOptionsRankingMiseEnPlace: any;
  dossiersByProfils: DashboardDossierStatut[];

  constructor(
    private modalService: NgbModal,
    private _dashboardAllMarcheService: DashboardAllMarcheService,
    private _dashboardGlobalService: DashboardGlobalService,
    private corporateService: NewDashboardCorporateService,

  ) {}

  ngOnInit() {
    //this.rankingTacheEnCours("_");
    //this.rankingTacheMiseEnPlace("_");
    this.portefeuilleTachesParMarche("_");
    this.getDossiersByStatutAndProfil();
  }

  //
  portefeuilleTachesParMarche(codeAgence) {
    this._dashboardAllMarcheService
      .portefeuilleTachesParMarche("_", codeAgence)
      .pipe(first())
      .subscribe(
        response => {
          this.dossiersDepartements = response;
        },
        error => {
          console.log(error);
        }
      );
  }

  portefeuilleTachesParDepartement(codeDepartement) {
    this._dashboardAllMarcheService
      .portefeuilleTachesParDepartement("_", "_", codeDepartement)
      .subscribe((data: QuantiteDossierPortefeuilleParProfileDTO[]) => {
        console.log(data);
        this.dossiersProfilesArray[codeDepartement] = data;
      });
  }
  //

  getDossiersByStatutAndProfil() {
    this.corporateService
      .getDossiersByStatutAndProfilGlobal()
      .subscribe(data => {
        console.log(data);
        this.dossiersByProfils = data;
      });
  }

  /*
  rankingTacheEnCours(codeAgence) {
    this._dashboardAllMarcheService
      .rankingGestionnaireParMarche("_", codeAgence, "ENCOURS")
      .pipe(first())
      .subscribe(
        data => {
          const series = [];
          const categories = data.map(item => item.name);
          const seriesData = data.map(item => item.valeur);
          series.push({ name: "EnCours", data: seriesData });

          this.chartOptionsRankingEncours = {
            chart: {
              type: "bar"
            },
            title: {
              text: "Dossiers en cours par gestionnaire"
            },
            subtitle: {
              text: null
            },
            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              //x: 250,
              y: 100,
              floating: false,
              borderWidth: 1,
              backgroundColor: "#FFFFFF",
              shadow: true
            },
            xAxis: {
              categories: categories,
              title: {
                text: null
              }
            },
            yAxis: {
              min: 0,
              title: {
                text: "Qte dossier",
                align: "high"
              },
              labels: {
                overflow: "justify"
              }
            },
            tooltip: {
              valueSuffix: " Qte"
            },
            plotOptions: {
              bar: {
                dataLabels: {
                  enabled: true
                },
                showInLegend: true
              },
              series: {
                stacking: "normal"
              }
            },
            credits: {
              enabled: false
            },
            series: series
          };
        },
        error => {
          console.log(error);
        }
      );
  }

  rankingTacheMiseEnPlace(codeAgence) {
    this._dashboardAllMarcheService
      .rankingGestionnaireParMarche("_", codeAgence, "MISEENPLACE")
      .pipe(first())
      .subscribe(
        data => {
          const series = [];
          const categories = data.map(item => item.name);
          const seriesData = data.map(item => item.valeur);
          series.push({ name: "Mis en place", data: seriesData });

          this.chartOptionsRankingMiseEnPlace = {
            chart: {
              type: "bar"
            },
            title: {
              text: "Dossiers mis en place par gestionnaire"
            },
            subtitle: {
              text: null
            },
            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              //x: 250,
              y: 100,
              floating: false,
              borderWidth: 1,
              backgroundColor: "#FFFFFF",
              shadow: true
            },
            xAxis: {
              categories: categories,
              title: {
                text: null
              }
            },
            yAxis: {
              min: 0,
              title: {
                text: "Qte dossier",
                align: "high"
              },
              labels: {
                overflow: "justify"
              }
            },
            tooltip: {
              valueSuffix: " Qte"
            },
            plotOptions: {
              bar: {
                dataLabels: {
                  enabled: true
                },
                showInLegend: true
              },
              series: {
                stacking: "normal"
              }
            },
            credits: {
              enabled: false
            },
            series: series
          };
        },
        error => {
          console.log(error);
        }
      );
  }*/
}
